export enum AsyncDataTransformer {
  Options = 'options',
  OptionGroups = 'option-groups',
  AccordionGroups = 'accordion-groups',
}
